"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardEditorContainer_1 = require("../../../../../../../shared/components/containers/CardEditorContainer");
var CardRowButtonSet_1 = require("../../../../../../../shared/components/editors/CardRowButtonSet");
var CardRowSelectEditor_1 = require("../../../../../../../shared/components/editors/CardRowSelectEditor");
var CardRowTextAreaEditor_1 = require("../../../../../../../shared/components/editors/CardRowTextAreaEditor");
var CardRowTextEditor_1 = require("../../../../../../../shared/components/editors/CardRowTextEditor");
var notificationHelper_1 = require("../../../../../../../shared/helpers/notificationHelper");
var BrandLocaleEditor = /** @class */ (function (_super) {
    __extends(BrandLocaleEditor, _super);
    function BrandLocaleEditor(props) {
        return _super.call(this, props) || this;
    }
    BrandLocaleEditor.prototype.componentWillMount = function () {
        var _this = this;
        if (this.props.record) {
            var _item = this.props.data.getById(this.props.record.key);
            if (_item) {
                this.setState({
                    app_language_id: _item.app_language_id,
                    app_language_title: _item.app_language_title,
                    title: _item.title,
                    text: _item.text,
                    preview_text: _item.preview_text
                }, function () {
                    _this.props.state.setExtBreadCrumbPath(["Бренды", "Редактировать локализацию бренда"]);
                });
            }
        }
        else {
            this.setState({
                app_language_id: 0,
                app_language_title: "",
                title: "",
                text: "",
                preview_text: ""
            }, function () {
                _this.props.state.setExtBreadCrumbPath(["Бренды", "Создать локализацию бренда"]);
            });
        }
        this.doReSetRules();
    };
    BrandLocaleEditor.prototype.doReSetRules = function () {
        this.setState({
            app_language_rules: { isError: false },
            text_rules: { isError: false },
            title_rules: { isError: false },
            preview_text_rules: { isError: false },
        });
    };
    BrandLocaleEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((!this.state.title) || (this.state.title.length === 0)) {
            this.setState({ title_rules: { isError: true, errorMessage: "Поле [название] не заполнено!" } });
            return false;
        }
        if ((!this.state.text) || (this.state.text.length === 0)) {
            this.setState({ text_rules: { isError: true, errorMessage: "Поле [описание] не заполнено!" } });
            return false;
        }
        if ((this.state.app_language_id <= 0) || (this.state.app_language_title.length === 0)) {
            this.setState({ app_language_rules: { isError: true, errorMessage: "Язык не выбран!" } });
            return false;
        }
        return true;
    };
    BrandLocaleEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditData({
                key: this.props.record.key,
                app_language_id: this.state.app_language_id,
                title: this.state.title,
                text: this.state.text,
                preview_text: this.state.preview_text
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Локализация бренда изменена!");
            });
        }
    };
    BrandLocaleEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                app_language_id: this.state.app_language_id,
                brand_id: this.props.rootRecord.key,
                title: this.state.title,
                text: this.state.text,
                preview_text: this.state.preview_text
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Локализация бренда добавлена!");
            });
        }
    };
    BrandLocaleEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    BrandLocaleEditor.prototype.getFormTitle = function () {
        if (!this.props.record) {
            return "Новая локализация бренда";
        }
        else {
            return "Изменить локализацию бренда";
        }
    };
    BrandLocaleEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 620 },
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Язык:", placeholder: "Выберите язык" }, value: { key: this.state.app_language_id, value: this.state.app_language_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        app_language_id: newVal.key,
                        app_language_title: newVal.value,
                        app_language_rules: { isError: false }
                    });
                }, items: this.props.availLanguage, required: true, rules: this.state.app_language_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Название:", placeholder: "Введите название" }, value: this.state.title, onValueChanged: function (newVal) {
                    _this.setState({
                        title: newVal,
                        title_rules: { isError: false }
                    });
                }, required: true, rules: this.state.title_rules }),
            React.createElement(CardRowTextAreaEditor_1.default, { texts: { caption: "Превью:", placeholder: "Введите превью" }, value: this.state.preview_text, onValueChanged: function (newVal) {
                    _this.setState({ preview_text: newVal });
                }, rowsCount: 4, required: true, rules: this.state.preview_text_rules }),
            React.createElement(CardRowTextAreaEditor_1.default, { texts: { caption: "Описание:", placeholder: "Введите описание" }, value: this.state.text, onValueChanged: function (newVal) {
                    _this.setState({ text: newVal });
                }, rowsCount: 8, required: true, rules: this.state.text_rules }),
            React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: { btnEdit: "Сохранить", btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) })));
    };
    return BrandLocaleEditor;
}(React.Component));
exports.default = BrandLocaleEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/main_brands_list/ui/component/locales/BrandLocaleEditor.tsx
// module id = 1851
// module chunks = 0